
export interface ICompanyFormInfo {
  title: string;
  description: string;
}

export const COMPANY_FORM_INFO: Record<string, ICompanyFormInfo> = {
  notificationEmails: {
    title: 'Caixa de entrada do colaborador',
    description:
      'Endereço que recebe os avisos de atestado criado, aprovado, reprovado e arquivado. Em branco a ação não é feita.',
  },
  sendNotificationsWhenCreated: {
    title: 'Enviar documento › Conclusão do envio',
    description:
      'Concluído o envio do documento, um email e uma mensagem no whatsAap é enviada ao colaborador com o protocolo do atestado criado.',
  },
  sendNotificationsWhenApproved: {
    title: 'Followup › Ações > Aprovar',
    description:
      'Quando o atestado é Aprovado, o colaborador recebe um e-mail com os dados do documento.',
  },
  sendNotificationsWhenDisapproved: {
    title: 'Followup › Ações > Reprovar',
    description:
      'Quando o atestado é Reprovado, o colaborador recebe um e-mail com os dados do documento.',
  },
  sendNotificationsEmployeeWhenArchived: {
    title: 'Followup › Ações > Arquivar',
    description:
      'Quando o atestado é Arquivado, o colaborador recebe um e-mail com os dados do documento',
  },
  sendEmailToManagerWhenDocumentApproved: {
    title: 'Followup › Ações > Aprovar',
    description:
      'Quando o atestado é aprovado, o gestor recebe uma notificação.',
  },
  validateLatenessFromBackoffice: {
    title: 'Atestados lançados pelo RH não valida o atraso do documento.',
    description: 'Parâmetro para definir se valida atestado em atraso enviado pelo RH, diretamente pelo sistema interno.',
  },
  allowJustificationWhenApprovingTheDocument: {
    title: 'Followup › Ações > Aprovar',
    description: 'Antes da aprovação definitiva, um campo de texto é aberto para justificar a aprovação.',
  },
};

export const companyFormInfoId = (field: string) => `coachmark-company-${field}`;
